export default "__VITE_ASSET__CeZbn24W__"